import React from 'react';

import { usePostMessageContext } from 'src/providers';

export function useOuterContentHeightChanged() {
  const { postMessage } = usePostMessageContext();

  return React.useCallback((contentHeight: number) => {
    postMessage('outerContentHeightChanged', { height: `${contentHeight}px` });
  }, [postMessage]);
}
